/**
 * Événement de Vercel Analytics ou Speed Insights privé de la requête et du
 * fragment de son adresse. Les liens d'activation et de réinitialisation portent
 * un jeton (`token_hash` sur /auth et /reset-password, `access_token` dans le
 * fragment au retour d'une vérification Supabase) qui ne doit pas quitter le
 * navigateur : seul le chemin de la page est transmis.
 */
export function stripUrlQuery<T extends { url: string }>(event: T): T {
  return { ...event, url: event.url.split(/[?#]/, 1)[0] };
}
